import { createAction } from '../../libs/saga-utils';

const ns = 'user';

export const USER_TYPES = {
  LOGIN_REQUEST: `${ns}/LOGIN_REQUEST`,
  LOGIN_SUCCESS: `${ns}/LOGIN_SUCCESS`,
  LOGIN_FAILURE: `${ns}/LOGIN_FAILURE`,
  LOGIN_2FA_REQUIRED: `${ns}/LOGIN_2FA_REQUIRED`,

  LOGOUT_REQUEST: `${ns}/LOGOUT_REQUEST`,
  LOGOUT_SUCCESS: `${ns}/LOGOUT_SUCCESS`,
  LOGOUT_FAILURE: `${ns}/LOGOUT_FAILURE`,

  LOAD_LOCALSTORAGE_SUCCESS: `${ns}/LOAD_LOCALSTORAGE_SUCCESS`,
  LOAD_LOCALSTORAGE_FAILURE: `${ns}/LOAD_LOCALSTORAGE_FAILURE`,

  GET_CSRF_TOKEN_SUCCESS: `${ns}/GET_CSRF_TOKEN_SUCCESS`,
  GET_CSRF_TOKEN_FAILURE: `${ns}/GET_CSRF_TOKEN_FAILURE`,

  GET_DATA_REQUEST: `${ns}/GET_DATA_REQUEST`,
  GET_DATA_SUCCESS: `${ns}/GET_DATA_SUCCESS`,
  GET_DATA_FAILURE: `${ns}/GET_DATA_FAILURE`,
};

export const USER_ACTIONS = {
  loginRequest: createAction(USER_TYPES.LOGIN_REQUEST, (username, password, remember = true) => ({
    username,
    password,
    remember,
  })),
  loginSuccess: createAction(USER_TYPES.LOGIN_SUCCESS, (user) => ({ user })),
  loginFailure: createAction(USER_TYPES.LOGIN_FAILURE, (error) => ({ error })),
  login2faRequired: createAction(USER_TYPES.LOGIN_2FA_REQUIRED),

  logoutRequest: createAction(USER_TYPES.LOGOUT_REQUEST),
  logoutSuccess: createAction(USER_TYPES.LOGOUT_SUCCESS),
  logoutFailure: createAction(USER_TYPES.LOGOUT_FAILURE),

  loadLocalstorageSuccess: createAction(USER_TYPES.LOAD_LOCALSTORAGE_SUCCESS, (user) => ({ user })),
  loadLocalstorageFailure: createAction(USER_TYPES.LOAD_LOCALSTORAGE_FAILURE, (error) => ({ error })),

  getCsrfTokenSuccess: createAction(USER_TYPES.GET_CSRF_TOKEN_SUCCESS, () => {}),
  getCsrfTokenFailure: createAction(USER_TYPES.GET_CSRF_TOKEN_FAILURE, (error) => ({ error })),

  getDataRequest: createAction(USER_TYPES.GET_DATA_REQUEST),
  getDataSuccess: createAction(USER_TYPES.GET_DATA_SUCCESS, (user) => ({ user })),
  getDataFailure: createAction(USER_TYPES.GET_DATA_FAILURE, (error) => ({
    error,
  })),
};
